<a
    target="_blank"
    [ngClass]="{ 'card-disabled': !application?.url }"
    [attr.data-app-name]="application?.name"
    [attr.data-app-id]="application?.id"
    [attr.data-parentid]="application?.name"
    (click)="launch($event)"
>
    <hc-tile
        tight="true"
        [ngClass]="!application?.isFavorite && inFavoriteContainer ? 'remove-favorite' : ''"
        class="cdp-app-card-tile"
        [ngClass]="{ 'card-disabled-hover': !application?.url }"
    >
        <span
            class="cdp-fav-ico icon-star{{ application?.isFavorite ? ' favorited' : '-o' }}"
            hcTooltip="{{ application?.isFavorite ? 'Remove from' : 'Add to' }} favorites"
            (click)="favClicked($event)"
        ></span>
        <div [hcTooltip]="application?.action | appActionButtonTitle: application?.name">
            <div hcTileHeader [type]="'center'">
                <div class="card-logo-container">
                    <cdp-app-icon [app]="application"></cdp-app-icon>
                </div>
                <div class="card-title">
                    <span [innerHTML]="application?.name | searchHighlight: searchText"></span>
                </div>
                <div class="card-by" *ngIf="application?.providedBy">
                    By <span [innerHTML]="application?.providedBy | searchHighlight: searchText"></span>
                </div>
            </div>
        </div>
    </hc-tile>
</a>
